// src/components/sdk/components/TopHeader.tsx
import React from 'react';
import { Layout, Space, Select, Dropdown, Avatar, Typography } from 'antd';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';

const { Header } = Layout;
const { Title, Text } = Typography;

interface TopHeaderProps {
    t: (key: string, options?: any) => string;
    userInfo: { email: string; name: string };
    onLanguageChange: (lang: string) => void;
    onLogout?: () => void;
    isMobile?: boolean;
}

export const TopHeader: React.FC<TopHeaderProps> = ({
    t,
    userInfo,
    onLanguageChange,
    onLogout,
    isMobile = false,
}) => {
    const userMenuItems: MenuProps['items'] = [
        {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: t('sdkUser.logout') || '退出登录',
            danger: true,
            onClick: onLogout,
        },
    ];

    return (
        <Header style={{
            background: '#fff',
            padding: isMobile ? '0 12px' : '0 24px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderBottom: '1px solid #e8e8e8',
            height: 64,
            position: 'sticky',
            top: 0,
            zIndex: 100,
        }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Title level={isMobile ? 4 : 4} style={{ margin: 0, color: '#667eea', fontSize: isMobile ? 16 : undefined }}>
                    {isMobile ? 'SDK管理' : (t('sdk.title') || 'SDK 应用管理')}
                </Title>
            </div>
            <Space size={isMobile ? 8 : 16}>
                <Select
                    defaultValue="中文"
                    style={{ width: isMobile ? 80 : 100 }}
                    onChange={onLanguageChange}
                    options={[
                        { value: 'zh_CN', label: isMobile ? '中文' : '中文' },
                        { value: 'en_US', label: isMobile ? 'EN' : 'English' },
                    ]}
                    size={isMobile ? 'small' : 'middle'}
                />
                <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
                    <Space style={{ cursor: 'pointer', marginLeft: isMobile ? 4 : 8 }}>
                        <Avatar icon={<UserOutlined />} style={{ background: '#667eea', width: isMobile ? 28 : 32, height: isMobile ? 28 : 32 }} />
                        {!isMobile && <Text strong>{userInfo.name || userInfo.email || t('sdkUser.default') || '开发者'}</Text>}
                    </Space>
                </Dropdown>
            </Space>
        </Header>
    );
};